<template>
  <div>
    <b-card class="cardStyle" no-body>
      <div class="px-4 py-3">
        <b-row>
          <b-col class="pt-2 my-access-custom-text-center" cols="12" lg="6" md="6" sm="6" xl="6">
            <div class="header-info-text text-nowrap">
              <b-icon icon="person-lines-fill"></b-icon>
              View Site Team
            </div>
          </b-col>
          <b-col class="pt-2 my-access-custom-text-center" cols="12" lg="6" md="6" sm="6" xl="6">
            <div v-if="canManageAccess" class="text-style custom-float-right">
              <!-- To manage Application Access for users not listed below
              <span
                class="click"
                @click="
                  $router.push({
                    name: 'custom-application-access',
                    params: {
                      siteId: $route.params['siteId'],
                      studyId: $route.params['studyId'],
                    },
                  })
                "
                >Click here</span
              > -->
              If you do not see a member of your site staff listed below and need to request
              application access, please review the Application Access Manager section on the
              Support Page
            </div>
          </b-col>
        </b-row>
        <hr class="solid mt-2" />
        <b-row class="my-1">
          <b-col cols="12" lg="5" md="6" sm="6" xl="5">
            <b-icon class="position-absolute h-100 text-muted ml-2" icon="search"></b-icon>
            <b-form-input
              id="input-default"
              v-model="filter"
              class="rounded-pill"
              placeholder="Search for Site Staff"
              style="padding-left: 30px; background: #f4eff4"
              type="search"
            ></b-form-input>
          </b-col>
        </b-row>
      </div>
      <b-table
        id="my-team"
        :busy.sync="busy"
        :current-page="currentPage"
        :fields="myTeam()"
        :filter="filter"
        :items="siteTeam"
        :per-page="perPage"
        bordered
        borderless
        class="table-row-text my-team-striped"
        empty-text="There are no site team members."
        fixed
        hover
        primary-key="Id"
        responsive
        show-empty
        stacked="sm"
        striped
        thead-class="thMyTeam"
        @filtered="onFiltered"
      >
        <template #table-caption>
          <div class="px-3" style="display: flex; justify-content: space-between">
            <p v-if="siteTeam" style="font-size: 14px">
              <strong>{{ totalRows }}</strong>
              {{ totalRows > 1 && totalRows !== 0 ? 'members' : 'member' }}
            </p>
            <b-pagination
              v-if="totalRows > 1"
              v-model="currentPage"
              :per-page="perPage"
              :total-rows="totalRows"
              align="right"
              aria-controls="my-access-request"
              pills
              size="sm"
            ></b-pagination>
          </div>
        </template>
        <template #table-busy>
          <div class="text-center text-secondary my-2">
            <b-spinner class="align-middle"></b-spinner>
            <strong>Loading...</strong>
          </div>
        </template>
        <template v-slot:head()="data">
          <div class="my-team-table-header">
            {{ data.label }}
          </div>
        </template>
        <template #cell(actions)="row">
          <b-button
            v-if="row.item.emails.length > 0"
            class="mr-2 text-primary"
            pill
            variant="light"
            @click="toManageAccess(row.item, row.index)"
          >
            <b-icon icon="eye-fill"></b-icon>
            Manage Access
          </b-button>
        </template>
      </b-table>
    </b-card>
  </div>
</template>

<script>
  import tableFieldsMixin from '../../mixins/tableFieldsMixin';
  import _ from 'lodash';

  export default {
    mixins: [tableFieldsMixin],
    props: {
      siteId: String,
      studyId: String,
      canManageAccess: Boolean,
      studySite: Object,
    },
    data() {
      return {
        tableFields: [],
        siteTeam: [],
        busy: false,
        perPage: 10,
        currentPage: 1,
        totalRows: 0,
        filter: '',
      };
    },
    computed: {},
    watch: {
      $route() {
        this.siteTeam = [];
        this.getSiteTeam();
      },
    },
    created() {
      this.getSiteTeam();
    },
    methods: {
      toManageAccess(userInfo, index) {
        if (!this.canManageAccess) {
          this.$emit('redirectToOldCAM');
          return;
        }
        this.$store.commit('setUserDetails', {
          index: index,
          phoneNumber: '',
          firstName: userInfo.firstName,
          lastName: userInfo.lastName,
          emails: userInfo.emails,
          selectedEmail: userInfo.emails[0],
          personId: userInfo.personId,
        });
        this.$emit('showManageRequest');
      },
      onFiltered(filteredItems) {
        this.totalRows = filteredItems.length;
        this.currentPage = 1;
      },
      async getSiteTeam() {
        try {
          this.busy = true;
          let response = await axios.get(`/api/get-site-team`, {
            params: {
              site: this.siteId,
              study: this.studyId,
            },
          });
          if (response.status !== 204) {
            response.data['items'].forEach(element => {
              this.siteTeam.push({
                firstName: element['firstName'],
                lastName: element['lastName'],
                fullName: element['firstName'] + ' ' + element['lastName'],
                emails: element['emails'],
                phoneNumber: '',
                roles: element['roles'],
                ordering: element['ordering'],
                selectedEmail: element['emails'][0],
                personId: element['personID'],
              });
            });
            this.siteTeam = _.sortBy(this.siteTeam, 'ordering');
            this.totalRows = this.siteTeam.length;
            this.$emit('myTeam', this.siteTeam);
          }
        } catch (error) {
          console.error(error);
        }
        this.busy = false;
      },
    },
  };
</script>
<style scoped>
  .text-style {
    font-weight: 400;
    font-size: 14px;
    line-height: 28px;
    letter-spacing: 0.25px;
    color: #383838;
  }
  .click {
    cursor: pointer;
    color: #234ed0;
  }
</style>
